var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RegisterForm',{attrs:{"isApplicationRegister":true,"registerLandingId":_vm.registerLandingId,"registerApplicationId":_vm.registerApplicationId}})}
var staticRenderFns = []

export { render, staticRenderFns }